module.exports = __webpack_public_path__ + "static/media/TN-Women-Pants.68c8f62a.svg";